<select [ngModel]="value" (ngModelChange)="changeValue($event)">
    <option style="background-color: transparent;" value="transparent">X</option>
    <option style="background-color: yellow;" value="yellow"></option>
    <option style="background-color: lightgreen;" value="lightgreen"></option>
    <option style="background-color: lightskyblue;" value="lightskyblue"></option>
    <option style="background-color: orange;" value="orange"></option>
</select>